import axios from 'axios';
import { LOGIN_PATH } from '../../router/RouteConstants';

const BASE_URL = process.env.REACT_APP_AI_ASSISTANCE_HOST;
const axiosInstance = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const allCookies = document.cookie.split('; ');
            document.cookie = allCookies.forEach((cookie) => {
                const name = cookie.split('=')[0];
                if (!!name) document.cookie = `${name}=; path=/`;
            });

            window.location.replace(LOGIN_PATH);
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
